import React from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

/**
 * Custom 404 page — branded Heseda "page not found" experience.
 */
const NotFoundPage: React.FC = () => {
  const { t } = useTranslation('common');
  React.useEffect(() => { document.title = '404 — Heseda AI'; }, []);

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      minHeight: CSS.supports?.('min-height', '100dvh') ? '100dvh' : '100vh',
      width: '100vw',
      position: 'fixed', top: 0, left: 0, bottom: 0,
      background: 'linear-gradient(135deg, #ece9e6, #ffffff)',
      padding: '20px', textAlign: 'center', boxSizing: 'border-box',
      overflowY: 'auto',
    }}>
      <img src="/logo-512-colorful.png" alt="Heseda AI" style={{ width: 72, height: 72, marginBottom: 24 }} />
      <h1 style={{ fontSize: 48, fontWeight: 700, color: '#333', margin: 0 }}>404</h1>
      <p style={{ fontSize: 18, color: '#666', margin: '12px 0 32px' }}>
        {t('notFound.message', "The page you're looking for doesn't exist.")}
      </p>
      <Link
        to="/"
        style={{
          padding: '12px 32px', backgroundColor: '#db4437', color: '#fff',
          borderRadius: 8, textDecoration: 'none', fontSize: 16, fontWeight: 600,
          transition: 'background-color 0.2s',
        }}
        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#c3362f'; }}
        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#db4437'; }}
      >
        {t('notFound.goHome', 'Go to Home')}
      </Link>
    </div>
  );
};

export default NotFoundPage;
